import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';

const query = gql`
  query MembershipPlanContent {
    me {
      email
      id
      role
      isWaybetterMember
      firstName
      gameProfile(gameType: falkor) {
        ... on FalkorGameProfile {
          onboardingInformation
        }
      }
    }
  }
`;

// For some reason, using the default fetchPolicy with this query
// was resulting in it not running on the client. It would run on
// the server, and return the expected data, but it would not run
// again on the client, and would return null data.
// Using the 'network-only' policy seems to work around this issue.
export function useMembershipPlanContent() {
  const { data, error, loading } = useQuery(query, {
    fetchPolicy: 'network-only',
  });
  return { error, loading, user: data?.me };
}
